<script>
	import { onDestroy, getContext } from 'svelte'
	import { get_config_file } from '../library/scripts/utils'
	import { getCookie } from '../library/scripts/cookie'
	import { storeShowTools, storeElementID, storeData } from '../library/scripts/Store.svelte'
	import { styles } from '../library/scripts/styles'
	import Block from '../builder/BuilderBlock.svelte'
	import Tools from '../builder/tools/Tools.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../library/ShadersAndSpinners/SpinnerCircle.svelte'

	const globals = getContext('globals')
	const toolsBG = globals.colorMain
	const inputBgFocus = globals.inputBgFocus
	let backgroundColor = 'white'

	// get the config file and set it to data
	const start_site = async () => {
		let ID = getCookie('id')

		if (!ID) ID = 'loadSite'

		//for the config file
		const configFile = get_config_file(ID)

		configFile.then((value) => {
			storeData.set(value)
			globals.adminBgDark = value.adminBgDark
			globals.adminColorMain = value.adminColorMain
			globals.adminInputBgFocus = value.adminInputBgFocus
			globals.adminSelectTitle = value.adminSelectTitle
			globals.adminInputBorder = value.adminInputBorder
			globals.adminInputBg = value.adminInputBg
			globals.adminOptionBg = value.adminOptionBg
			globals.adminSelectHover = value.adminSelectHover
			globals.adminButtonColor = value.adminButtonColor
			globals.adminButtonBg = value.adminButtonBg
			globals.adminButtonBgHover = value.adminButtonBgHover
			backgroundColor = value.body
		})

		return configFile
	}

	const configFile = start_site()

	//to set the imported components width
	let parentWidth

	const open_tools = () => {
		document.getElementById('tools').style.width = '18vw'
		const builderBlock = document.getElementById('builderBlock')
		const navBar = document.getElementById('navbar')
		if (builderBlock) document.getElementById('builderBlock').style.width = '82vw'
		if (navBar) {
			document.getElementById('navbar').style.width = '82vw'
			document.getElementById('navbar').style.transition = 'width 500ms linear'
		}
	}

	let showTools
	const stoShowTools = storeShowTools.subscribe((value) => {
		showTools = value
	})

	$: if (showTools) {
		open_tools()
	}

	onDestroy(() => {
		stoShowTools
		storeElementID.set('--')
	})
	let y
</script>

{#await configFile}
	<Shader>
		<div slot="content">
			<Spinner info="site loading" color={inputBgFocus} />
		</div>
	</Shader>
{:then config}
	<main style="background-color:{backgroundColor}">
		<Block />

		<div class="tools" id="tools" use:styles={{ toolsBG }} bind:clientWidth={parentWidth}>
			<Tools {parentWidth} />
		</div>
	</main>
{/await}

<style>
	main {
		display: flex;
		width: 100%;
	}

	.tools {
		position: fixed;
		top: 0px;
		display: flex;
		justify-content: center;
		width: 0px;
		height: 100vh;
		z-index: 1;
		right: 0px;
		background-color: hsl(0, 0%, 70%);
		overflow-y: scroll;
		overflow-x: hidden;
		transition: 500ms ease-in-out;
	}
</style>
